import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login/login.vue';
import Home from '@/views/home/home.vue';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // ✅ 修改：根路径重定向到登录页（而不是 /nopass）
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/bggl',
      name: 'bggl',
      component: () => import('@/views/bggl/bggl.vue'),
      children: [
        {
          path: '/sfHouse',
          name: 'sfHouse',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-已收房源"
          },
          component: () => import('@/views/bggl/components/房源/sfHouse.vue'),
        },
        {
          path: '/sfHouseRent',
          name: 'sfHouseRent',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-待出租房源"
          },
          component: () => import('@/views/bggl/components/房源/sfHouseRent.vue'),
        },
        {
          path: '/submitContract',
          name: 'submitContract',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-待提交合同"
          },
          component: () => import('@/views/bggl/components/房源/submitContract.vue'),
        },
        {
          path: '/CfConfirm',
          name: 'CfConfirm',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-出房确认"
          },
          component: () => import('@/views/bggl/components/房源/CfConfirm.vue'),
        },
        {
          path: '/2_001_cxfy',
          name: '2_001_cxfy',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-查询房源"
          },
          component: () => import('@/views/bggl/components/2租房管理/001查询房源/2_001_cxfy.vue'),
        },
        {
          path: '/2_002_sf_ysfy',
          name: '2_002_sf_ysfy',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-收房-已收房源"
          },
          component: () => import('@/views/bggl/components/2租房管理/002收房-已收房源/2_002_sf_ysfy.vue'),
        },
        {
          path: '/2_003_sf_sfqr',
          name: '2_003_sf_sfqr',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-收房-收房确认"
          },
          component: () => import('@/views/bggl/components/2租房管理/003收房-收房确认/2_003_sf_sfqr.vue'),
        },
        {
          path: '/2_004_sczxhzp',
          name: '2_004_sczxhzp',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-上传装修后照片"
          },
          component: () => import('@/views/bggl/components/2租房管理/004上传装修后照片/2_004_sczxhzp.vue'),
        },
        {
          path: '/2_005_sf_sffk',
          name: '2_005_sf_sffk',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-收房-收房付款"
          },
          component: () => import('@/views/bggl/components/2租房管理/005收房-收房付款/2_005_sf_sffk.vue'),
        },
        {
          path: '/2_006_qzfy',
          name: '2_006_qzfy',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-潜在房源"
          },
          component: () => import('@/views/bggl/components/2租房管理/006潜在房源/2_006_qzfy.vue'),
        },
        {
          path: '/2_007_cf_dcz',
          name: '2_007_cf_dcz',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-出房-待出租"
          },
          component: () => import('@/views/bggl/components/2租房管理/007出房-待出租/2_007_cf_dcz.vue'),
        },
        {
          path: '/9_001_smwx',
          name: '9_001_smwx',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-小程序管理-上门维修"
          },
          component: () => import('@/views/bggl/components/9小程序管理/9_001_上门维修/9_001_smwx.vue'),
        },
        {
          path: '/tools',
          name: 'tool',
          meta: {
            title: "开发者工具箱",
            dtitle: "开发者工具箱-开发者工具箱-导表"
          },
          component: () => import('@/views/bggl/components/999工具箱/tools.vue'),
        },
      ]
    },
    {
      path: '/cfgl',
      name: 'cfgl',
      component: () => import('@/views/cfgl/cfgl.vue'),
      children: [
        {
          path: '/cfHouse',
          name: 'cfHouse',
          meta: {
            title: "办公管理",
            dtitle: "办公管理-已出房源"
          },
          component: () => import('@/views/cfgl/components/cfHouse.vue'),
        },
      ]
      },

    {
      path: '/moneyPlan',
      name: 'moneyPlan',
      component: () => import('@/views/moneyPlan/moneyPlan.vue'),
      children: [
        {
          path: '/sfPlan',
          name: 'sfPlan',
          meta: {
            title: "收付款计划",
            dtitle: "收付款计划-付款"
          },
          component: () => import('@/views/moneyPlan/sfPlan.vue'),
        },
        {
          path: '/sfPlanCheck',
          name: 'sfPlanCheck',
          meta: {
            title: "收付款计划",
            dtitle: "收付款计划-付款审核"
          },
          component: () => import('@/views/moneyPlan/sfPlanCheck.vue'),
        },
        {
          path: '/cfPlan',
          name: 'cfPlan',
          meta: {
            title: "收付款计划",
            dtitle: "收付款计划-收款"
          },
          component: () => import('@/views/moneyPlan/cfPlan.vue'),
        },
        {
          path: '/cfPlanCheck',
          name: 'cfPlanCheck',
          meta: {
            title: "收付款计划",
            dtitle: "收付款计划-收款审核"
          },
          component: () => import('@/views/moneyPlan/cfPlanCheck.vue'),
        },
      ]
    },
    
    {
      path: '/erp',
      name: 'erp',
      component: () => import('@/views/erp/erp.vue'),
    },
    {
      path: '/tools/export',
      name: 'tools',
      meta: {
        title: "业务员工具箱",
        dtitle: "业务员工具箱-导出工具-导出excel"
      },
      component: () => import('@/views/bggl/components/999工具箱/exportBaseBase.vue'),
    },
    {
      path: '/tools/repair',
      name: '9_001_smwx_v2',
      meta: {
        title: "办公管理",
        dtitle: "办公管理-小程序管理-上门维修_v2"
      },
      component: () => import('@/views/bggl/components/9小程序管理/9_001_上门维修_2/9_001_smwx.vue'),
    },
    {
      path: '/tools/createHirePlan',
      name: 'createHirePlan',
      meta: {
        title: "办公管理",
        dtitle: "办公管理-业务员工具箱-生成出房收款计划"
      },
      component: () => import('@/views/bggl/components/9小程序管理/9_002_生成出房收款计划/9_002_hireHousePayPlan.vue'),
    },
    {
      path: '/tools/check_cfsk',
      name: '2_101_check_cfsk',
      meta: {
        title: "办公管理",
        dtitle: "办公管理-检查-出房收款检查"
      },
      component: () => import('@/views/bggl/components/2租房管理/2_101_出房收款核查/2_101_check_cfsk.vue'),
    },
    {
      path: '/nopass',
      name: 'nopass',
      meta: {
        title: "禁止访问",
        dtitle: "禁止访问"
      },
      component: () => import('@/views/bggl/components/999工具箱/nopass.vue'),
    },
  ]
});

// ✅ 修改：全局导航守卫
router.beforeEach((to, from, next) => {
  // ✅ 将 /nopass 加入白名单，彻底解决循环问题
  const whiteList = ['/login', '/nopass', '/tools', '/tools/*'];
  const isLogin = store.state.isLogin;

  // ✅ 双重保险：如果已经在 /nopass，直接放行
  if (to.path === '/nopass') {
    next();
    return;
  }

  if (!isLogin && to.path !== '/login' && !whiteList.some(path => to.path.startsWith(path))) {
    // 未登录，且访问的不是白名单页面 → 跳转到 /nopass
    next('/nopass');
  } else {
    // 已登录，或目标是白名单页面 → 正常放行
    next();
  }
});

export default router;